exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.test-show-result-form-container[data-v-1a507ffc] {\n    display: flex;\n    align-items: center;\n}\n.test-show-result-form-icon[data-v-1a507ffc] {\n    display: block;\n    margin: 0 auto;\n}\n", ""]);

// exports
